import { ReactComponent as Trade } from 'assets/icons/icon-trade.svg';

export default Trade;
